/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Whtr_HintInputs */

const en_us2_body_assessment_whtr_hint = /** @type {(inputs: Body_Assessment_Whtr_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The main number here: better evidence behind it than body fat, and a far narrower range.`)
};

const pt_br2_body_assessment_whtr_hint = /** @type {(inputs: Body_Assessment_Whtr_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É o número principal daqui: tem evidência melhor que o percentual de gordura e uma faixa bem mais estreita.`)
};

const es_419_body_assessment_whtr_hint = /** @type {(inputs: Body_Assessment_Whtr_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El número principal aquí: tiene mejor evidencia que el porcentaje de grasa y un rango mucho más estrecho.`)
};

const pt_pt2_body_assessment_whtr_hint = /** @type {(inputs: Body_Assessment_Whtr_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É o número principal aqui: tem melhor evidência do que a percentagem de gordura e um intervalo bem mais estreito.`)
};

const fr_fr2_body_assessment_whtr_hint = /** @type {(inputs: Body_Assessment_Whtr_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le chiffre principal ici : mieux étayé que la masse grasse, avec une fourchette bien plus étroite.`)
};

const de_de2_body_assessment_whtr_hint = /** @type {(inputs: Body_Assessment_Whtr_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die wichtigste Zahl hier: besser belegt als der Körperfettanteil und mit einer viel engeren Spanne.`)
};

const it_it2_body_assessment_whtr_hint = /** @type {(inputs: Body_Assessment_Whtr_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È il numero principale qui: ha prove migliori della percentuale di grasso e un intervallo molto più stretto.`)
};

/**
* | output |
* | --- |
* | "The main number here: better evidence behind it than body fat, and a far narrower range." |
*
* @param {Body_Assessment_Whtr_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_whtr_hint = /** @type {((inputs?: Body_Assessment_Whtr_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Whtr_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_whtr_hint(inputs)
	if (locale === "es-419") return es_419_body_assessment_whtr_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_whtr_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_whtr_hint(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_whtr_hint(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_whtr_hint(inputs)
	return en_us2_body_assessment_whtr_hint(inputs)
});
export { body_assessment_whtr_hint as "body-assessment.whtr_hint" }